
export const update_sessionId = 'update_sessionId';

export const update_changeSessionIdMethod = 'update_changeSessionIdMethod';

export const update_isChange = 'update_isChange';

export const update_newSessionMethod = 'update_newSessionMethod'; 

export const update_refreshSessionListMethod = 'update_refreshSessionListMethod';

export const update_baseModel = 'update_baseModel';

export const update_enhancedModel = 'update_enhancedModel';

export const update_modelType = 'update_modelType';

export const update_submitMsg = 'update_submitMsg';

export const update_submitFileList = 'update_submitFileList';

export const update_chatType = 'update_chatType';